export const isNerActive = (isNerEnabled: string) =>
  /true/.test(isNerEnabled);